export default __webpack_public_path__ + "static/media/image.365-ventures-private-limited.5545f076.png";